import React, { useEffect } from "react";
import { Button } from "antd";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { getTranslation } from "../../utils/helper";

const SettingMenu = ({ history, setting, settingType, setSettingType }) => {
  const { user } = useSelector(state => state.auth);
  const roles = user?.roles;
  const userAccountType = user?.company?.accountType;
  const isPartner = roles?.includes("partner");
  const isCompany = roles?.includes("company_admin");
  const settingTypeDefault = !isPartner ? "general" : "brand";

  useEffect(() => {
    if (
      [
        "general",
        "notification",
        "integration",
        "language",
        "contact-list",
        "contact-list/upload",
        "brand",
        "webhook-configuration",
        "routing-engine",
      ].includes(settingType)
    ) {
      history.push(`/settings/${settingType}`);
    } else {
      history.push(`/settings/${settingTypeDefault}`);
    }
  }, [settingType]);

  return (
    <div className="SettingMenu">
      {!isPartner && (
        <>
          <Button
            className={settingType === "general" && "active"}
            type="text"
            onClick={() => setSettingType("general")}>
            {getTranslation(setting, "Settings", "General Settings")}
          </Button>
          <Button
            className={settingType === "notification" && "active"}
            type="text"
            onClick={() => setSettingType("notification")}>
            {getTranslation(setting, "Settings", "Notification Settings")}
          </Button>
          <Button
            className={settingType === "integration" && "active"}
            type="text"
            onClick={() => setSettingType("integration")}>
            {getTranslation(setting, "Settings", "Integration")}
          </Button>
          <Button
            className={settingType === "language" && "active"}
            type="text"
            onClick={() => setSettingType("language")}>
            {getTranslation(setting, "Settings", "Language")}
          </Button>
          <Button
            className={settingType.includes("contact-list") && "active"}
            type="text"
            onClick={() => setSettingType("contact-list")}>
            {getTranslation(setting, "Settings", "Contact List")}
          </Button>
          <Button
            className={settingType.includes("webhook-configuration") && "active"}
            type="text"
            onClick={() => setSettingType("webhook-configuration")}>
            {getTranslation(setting, "Settings", "Webhook Configuration")}
          </Button>
          <Button
            className={settingType === "routing-engine" && "active"}
            type="text"
            onClick={() => setSettingType("routing-engine")}>
            {getTranslation(setting, "Settings", "Routing Engine")}
          </Button>
        </>
      )}
      {isCompany ? (
        userAccountType === "WHITE_LABEL" && (
          <Button className={settingType === "brand" && "active"} type="text" onClick={() => setSettingType("brand")}>
            {getTranslation(setting, "Settings", "Brand Settings")}
          </Button>
        )
      ) : (
        <>
          <Button className={settingType === "brand" && "active"} type="text" onClick={() => setSettingType("brand")}>
            {getTranslation(setting, "Settings", "Brand Settings")}
          </Button>
          <Button
            className={settingType === "language" && "active"}
            type="text"
            onClick={() => setSettingType("language")}>
            {getTranslation(setting, "Settings", "Language")}
          </Button>
        </>
      )}
    </div>
  );
};

export default withRouter(SettingMenu);
